import { Box, Typography } from '@mui/material';

import RequiredIndicator from '@/components/common/RequiredIndicator';
import { QuestionProps } from '@/models/Question';

function HeaderText({ question }: { question: QuestionProps }) {
  if (!question) return null;
  return (
    <Box display='flex' flexDirection='column' alignItems='left'>
      <Typography style={{ marginTop: '12px', marginBottom: '16px' }} variant='h3'>
        {question.questionText} {question.questionNeeded && <RequiredIndicator />}
      </Typography>
      {question.questionNote && (
        <Typography style={{ marginTop: '5px' }}>{question.questionNote}</Typography>
      )}
    </Box>
  );
}

export default HeaderText;
